// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3yEcP","modalFooterButton":"ModalNotes_modalFooterButton__3uKnw"};